module.exports = __webpack_public_path__ + "static/t4-c88c32f609bab575763a285b526373e6.svg";